import { deskCard, deskEyebrow, deskMuted } from "./salesDeskStyles";
import { salesDeskQuoteInboxCopy, type SalesDeskReturnedQuote } from "./useSalesDeskConfigure";

export function SalesDeskConfigure({
  onBack,
  receipts,
}: {
  onBack: () => void;
  receipts: { quotes: SalesDeskReturnedQuote[]; loading: boolean; error: string | null };
}) {
  const returned = receipts;

  return (
    <div>
      <button type="button" onClick={onBack} className="text-sm font-semibold text-[#164b43] dark:text-emerald-300">
        ← Starting point
      </button>
      <p className={`${deskEyebrow} mt-4`}>Configure</p>
      <h1 className="mt-2 text-[32px] font-semibold leading-[1.15] tracking-[-1px]">Open their builder.</h1>
      <p className={`mt-3 max-w-[40rem] ${deskMuted}`}>
        IdeaRoom still builds the quote. A return attaches to one open lead only when the email and the phone both match. Every other return waits here.
      </p>
      <section className={`${deskCard} mt-8`}>
        <h2 className="text-[21px] font-semibold">Quotes that came back</h2>
        {returned.error ? <p className="mt-4 text-sm text-red-800 dark:text-red-200">{returned.error}</p> : null}
        {returned.loading ? <p className={`mt-4 ${deskMuted}`}>Loading returned quotes…</p> : null}
        {!returned.loading && !returned.error && returned.quotes.length === 0 ? (
          <p className={`mt-4 ${deskMuted}`}>No quotes have come back yet. The dealer IdeaRoom link is not stored on this desk.</p>
        ) : null}
        <div className="mt-2">
          {returned.quotes.map((quote) => {
            const waiting = salesDeskQuoteInboxCopy(quote.match);
            return (
              <div key={quote.id} className="border-b border-[#dce3dc] py-4 last:border-b-0 dark:border-zinc-700">
                <p className="text-sm font-semibold">{quote.name}</p>
                <p className="mt-1 text-xs text-[#687772] dark:text-zinc-400">
                  {[quote.email, quote.phone].filter(Boolean).join(" · ") || "No email or phone"}
                </p>
                {quote.match.kind === "attached" ? (
                  <p className="mt-2 text-sm text-[#164b43] dark:text-emerald-200">
                    Attached to {quote.leadName ?? "one open lead"}. The name on the quote is only a check.
                  </p>
                ) : (
                  <p className={`mt-2 ${deskMuted}`}>{waiting}</p>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
